import { ObjectSchema } from 'yup'

export function isInputValid(input: object, schema: ObjectSchema): boolean {
  return schema.isValidSync(input)
}
